export default __webpack_public_path__ + "static/media/amazon.346411e0.png";